<template>
    <div class="recipes">
        <h1>{{ msg }}</h1>
        <div class="cards">
            <div class="card" v-for="recipe in recipes" :key="recipe.id">
                <RouterLink
                    :to="{ name: 'recipe', params: { id: recipe.urlId }}"
                    class="card__inner"
                >
                    <!--<img :src="`${recipe.imageUrl}`" :alt="recipe.name" class="card__img">-->
                    <img
                        :src="`https://firebasestorage.googleapis.com/v0/b/recipe-app-475a9.appspot.com/o/${recipe.imageName}?alt=media`"
                    />
                    <div class="card__text">
                        <h2 class="card__title">{{ recipe.name }}</h2>
                        <ul class="card__details">
                            <li class="card__detail text--light">
                                {{ parseInt(recipe.prepTime) + parseInt(recipe.cookTime) }}
                                <br />
                                <span class="text--ucase text--xsmall">Minutes</span>
                            </li>
                            <li class="card__detail text--light">
                                {{ getIngredientsLength(recipe.sectionIds) }}
                                <br />
                                <span class="text--ucase text--xsmall">Ingredients</span>
                            </li>
                            <li class="card__detail text--light">
                                {{ recipe.servings }}
                                <br />
                                <span class="text--ucase text--xsmall">Servings</span>
                            </li>
                        </ul>
                    </div>
                    <!--<app-recipe :recipe="recipe"></app-recipe>-->
                </RouterLink>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import firebase from "firebase";
import { storage } from "../../firebaseConfig.js";

export default {
    name: "Recipes",
    props: {
        msg: String
    },

    created() {
        console.log(this.recipes);
    },

    computed: {
        ...mapGetters(["recipes", "sections"]),
        ...mapActions(["getImageUrl"])
    },

    methods: {
        getIngredientsLength(sectionNumbers) {
            let ingredientsLength = 0;
            sectionNumbers.forEach((section, index) => {
                if (this.sections[section]) {
                    // need this check because to prevent an undefined error because the data isn't fully loaded yet on initial load
                    ingredientsLength += this.sections[section].ingredients
                        .length;
                }
            });

            return ingredientsLength;
        }
    }
};
</script>
